'use client';

import { useState } from "react";
import Modal from "./Modal";
import CustomButton from "../forms/CustomButton";

import useAddCurriculumModal from "@/app/hooks/useAddCurriculumModal";

import apiService from "@/app/services/apiService";
import { useRouter } from "next/navigation";

const AddCurriculumModal = () => {
    //
    // States

    const [currentStep, setCurrentStep] = useState(1);
    const [errors, setErrors] = useState<string[]>([]);
    const [dataName, setDataName] = useState('');
    const [dataEmail, setDataEmail] = useState('');
    const [dataCargo, setDataCargo] = useState('');
    const [dataAddress, setDataAddress] = useState('');
    const [dataContact, setDataContact] = useState('');
    const [dataOver, setDataOver] = useState('');
    const [dataSocialLink, setDataSocialLink] = useState('');
        
    //
    //

    const AddCurriculum = useAddCurriculumModal();
    const router = useRouter()

    //
    // Set datas
    // Submit

    const submitForm = async () => {
        console.log('submitForm');

        if (
            dataName &&
            dataEmail &&
            dataCargo &&
            dataAddress &&
            dataContact &&
            dataOver &&
            dataSocialLink
         ) {
            const formData = new FormData();
            formData.append('name', dataName);
            formData.append('email', dataEmail);
            formData.append('cargo', dataCargo);
            formData.append('address', dataAddress);
            formData.append('contact', dataContact);
            formData.append('over', dataOver);
            formData.append('socialLink', dataSocialLink);
            
            const response = await apiService.post('/api/contacts/curriculum/', formData);

            if (response.success) {
                console.log('Success :-)');

                router.push('/?added=true');

                AddCurriculum.close();
            } else {
                console.log('Error');

                const tmpErrors: string[] = Object.values(response).map((error: any) => {
                    return error;
                })

                setErrors(tmpErrors)
            }
        
        }
    }

    //
    //

    const content = (
        <>
            {currentStep == 1 ? (
                <>
                    <h2 className="mb-6 text-2xl">Candidate-se a uma vaga!</h2>

                    <div className="pt-3 pb-6 space-y-4">                        
                        <div className="flex flex-col space-y-2">
                            <label>Digite seu nome completo</label>
                            <input
                                type="text"
                                value={dataName}
                                onChange={(e) => setDataName(e.target.value)}
                                className="w-full p-4 border border-gray-600 rounded-xl"
                            />
                        </div>

                        <div className="flex flex-col space-y-2">
                            <label>Digite seu melhor email</label>
                            <input
                                type="email"
                                value={dataEmail}
                                onChange={(e) => setDataEmail(e.target.value)}
                                className="w-full p-4 border border-gray-600 rounded-xl"
                            ></input>
                        </div>
                    </div>

                    <CustomButton 
                        label="Next 👉"
                        onClick={() => setCurrentStep(2)}
                        className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                    />
                </>
            ) : currentStep == 2 ? (
                <>
                    <h2 className="mb-6 text-2xl">Qual a sua área?</h2>

                    <div className="pt-3 pb-6 space-y-4">
                        <div className="flex flex-col space-y-2">
                            <label>Se candidatar a vaga de:</label>
                            <input
                                type="text"
                                value={dataCargo}
                                onChange={(e) => setDataCargo(e.target.value)}
                                className="w-full p-4 border border-gray-600 rounded-xl"
                            />
                        </div>

                        <div className="flex flex-col space-y-2">
                            <label>Endereço completo</label>
                            <input
                                type="text"
                                value={dataAddress}
                                onChange={(e) => setDataAddress(e.target.value)}
                                className="w-full p-4 border border-gray-600 rounded-xl"
                            ></input>
                        </div>
                    </div>

                    <CustomButton 
                        label='Previous'
                        className='w-full py-4 mb-2 bg-black hover:bg-gray-800 text-white text-center rounded-xl transition cursor-pointer'
                        onClick={() => setCurrentStep(1)}
                    />
                    
                    <CustomButton 
                        label="Next"
                        onClick={() => setCurrentStep(3)}
                        className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                    />
                </>
            ) : (
                <>
                    <h2 className="mb-6 text-2xl">Finalizar</h2>

                    <div className="pt-3 pb-6 space-y-4">
                        <div className="flex flex-col space-y-2">
                            <label>Contato</label>
                            <input
                                type="number"
                                value={dataContact}
                                onChange={(e) => setDataContact(e.target.value)}
                                className="w-full p-4 border border-gray-600 rounded-xl"
                            />
                        </div>
                        <div className="flex flex-col space-y-2">
                            <label>Perfil rede social</label>
                            <input
                                type="text"
                                value={dataSocialLink}
                                onChange={(e) => setDataSocialLink(e.target.value)}
                                className="w-full p-4 border border-gray-600 rounded-xl"
                            />
                        </div>
                        <div className="flex flex-col space-y-2">
                            <label>Fale sobre você</label>
                            <textarea
                                rows={4}
                                value={dataOver}
                                onChange={(e) => setDataOver(e.target.value)}
                                className="w-full p-4 border border-gray-600 rounded-xl"
                            />
                        </div>
                    </div>

                    {errors.map((error, index) =>{
                        return (
                            <div
                                key={index}
                                className="p-5 mb-4 bg-nat-reggaex text-white rounded-xl opacity-80"
                            >
                                {error}
                            </div> 
                        )
                    })}

                    <CustomButton 
                        label="👈 Previous"
                        className='w-full py-4 mb-2 bg-black hover:bg-gray-800 text-white text-center rounded-xl transition cursor-pointer'
                        onClick={() => setCurrentStep(2)}
                    />
                    
                    <CustomButton 
                        label="Submit 📤"
                        onClick={submitForm}
                        className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                    />
                </>            
            )}
        </>
    )

    return (
        <>
            <Modal
                isOpen={AddCurriculum.isOpen}
                close={AddCurriculum.close}
                label="Trabalhe conosco"
                content={content}
            />
        </>
    )
}

export default AddCurriculumModal;